import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { CompanyOnboardingFile, OnboardingStep } from '@/types';
    import { ChevronDown } from 'lucide-vue-next';
    import {
        DropdownMenu,
        DropdownMenuContent,
        DropdownMenuItem,
        DropdownMenuTrigger,
    } from '@/components/ui/dropdown-menu';
    import { Button } from '@/components/ui/button';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingTableFilesDownload',
  props: {
    companyOnboardingStep: {},
    files: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const downloadFile = (file: CompanyOnboardingFile) => {
        window.open(
            route('v2.onboarding.files.download', {
                companyOnboardingStep: props.companyOnboardingStep.id,
                storageFile: file.id,
            }),
            '_blank',
        );
    };

return (_ctx: any,_cache: any) => {
  return (!!_ctx.files?.length)
    ? (_openBlock(), _createBlock(DataTableActions, {
        key: 0,
        data: _ctx.companyOnboardingStep
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DropdownMenu), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "continue",
                    size: "xs"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('onboarding.download.title', { count: _ctx.files.length })) + " ", 1),
                      _createVNode(_unref(ChevronDown))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DropdownMenuContent), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                    return (_openBlock(), _createBlock(_unref(DropdownMenuItem), {
                      onClick: ($event: any) => (downloadFile(file))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(file.original_filename), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 256))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]))
    : _createCommentVNode("", true)
}
}

})